import {FC, useContext} from 'react';
import {Flex} from './layouts';
import ContactModalContext from "../../context/ContactModalContext";
import WhiteLabelContext from "../../context/WhiteLabelContext";
import {useTranslation} from "react-i18next";

const ReportIncorrectDataLink: FC = () => {
  const { t } = useTranslation();
  const { setContactModalOpen } = useContext(ContactModalContext);
  const { canSendConsumerMessages } = useContext(WhiteLabelContext);

  return ( canSendConsumerMessages && (
    <Flex alignItems="center" justifyContent="center">
      <strong>{t('Kloppen gegevens niet?')}</strong>&nbsp;{t('Klik dan')}&nbsp;<a onClick={(e) => {e.preventDefault(); setContactModalOpen(true)}} css={{'textDecoration': 'underline', 'cursor': 'pointer'}}>{t('hier')}</a>.
    </Flex>
  ));
}

export default ReportIncorrectDataLink;